<template>
  <div class="dots">
    <div v-for="i in total" :key="i" class="dot" :class="{ active: i === current }" />
  </div>
</template>
<script lang="ts">
export default {
  props: {
    total: {
      type: Number,
      required: true,
    },
    current: {
      type: Number,
      required: true,
    },
  },
}
</script>
<style lang="sass">
.dots
  width: 28px
  display: flex
  flex-direction: column
  align-items: center
  position: fixed
  right: 10px
  top: 50%
  z-index: 100
  transform: translateY(-50%)
  -ms-transform: translateY(-50%)
  -webkit-transform: translate3d(0, -50%, 0)
  pointer-events: none
  .dot
    width: 5px
    height: 5px
    margin: 8px
    border-radius: 50%
    background-color: #CED4DA
    transition: all 0.1s ease-in-out
    &.active
      background: var(--uePurple)
      width: 12px
      height: 12px

@media screen and (max-width: 500px)
  .dots
    right: 2px
</style>
